import {
  Card,
  Col,
  Form,
  Modal,
  notification,
  Row,
  Select,
  Skeleton,
  Table,
  DatePicker, message
} from "antd";
import Button from "atoms/Button";
import queryKeys from "common/queryKey";
import { useFetch } from "hooks/useFetch";
import { useScrollFetch2 } from "hooks/useScrollFetch2";
import { sumBy } from "lodash";
import dayjs from "dayjs";
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useSelector } from "react-redux";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  getLiveConversionRate,
  getTempEngagementFormData,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import UIModal from "reusableComponent/UIModal";
import styled from "styled-components";
import { currencyAmount, } from "utils/functions";
import currencyMasterData from "common/currencyRateMasterData.json";
import { useMutate } from "hooks/useMutate";
import moment from "moment";
import { useLocation } from 'react-router-dom';


const labelStyle = {
  width: "150px",
  display: "inline-block",
  textAlign: "start",
  color: "#000000",
};

const StyledTable = styled(Table)`
  .highlighted-disabled {
    background-color: #f5f5f5;
    color: #999;
    pointer-events: none;
    opacity: 1;
  }
`;

const JobCloserFields = ({
  update,
  handleCloseEngagementViaModal,
  validationError,
  disabled, // get disabled prop from parent
}) => {
  const history = useHistory();
  const form = Form.useFormInstance();
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);

  const [showBilling, setShowBilling] = React.useState(false);
  const [actualChargeout, setActualChargeout] = useState("");
  const [budjetChargeout, setBudjetChargeout] = useState("");
  const [profitLoss, setProfitLoss] = useState(0);
  const [
    isUnapprovedTimesheetModalVisible,
    setIsUnapprovedTimesheetModalVisible,
  ] = useState(false);
  const [isLoadingUnapprovedTimesheets, setIsLoadingUnapprovedTimesheets] =
    useState(false);
  const [isClaimsModalVisible, setIsClaimsModalVisible] = useState(false);
  const [unapprovedData, setUnapprovedData] = useState([]);
  const [claimsData, setClaimsData] = useState([]);
  const location = useLocation();
  const hasRedirected = useRef(false); // Guard redirect
  const [shouldClone, setShouldClone] = useState(false);

  const formValues = form.getFieldsValue(true);
  const tempEngagementFormData = useSelector((state) =>
    getTempEngagementFormData(state)
  );
  const convertionRate = useSelector(getLiveConversionRate);

  const { id } = useParams();
  const originalIdRef = useRef(id); // Track original ID

  const {
    getEngagementById,
    getBillingById,
    getTimeSheetByengagementId,
    getClaims,
    getAllBillList,
    getEngagementCloneByEngagementId
  } = queryKeys;
  const queryParams = new URLSearchParams();
  queryParams.append("engagementid", id);

  const queryString = queryParams.toString();
  const { key, url } = getEngagementById(id);
  const paramsClone = new URLSearchParams(location.search);
  const isCloned = paramsClone.get('cloned') === 'true';
  const [isCloning, setIsCloned] = useState(false);
  const [cloneloader, setLoader] = useState(false);
  const [cloneTrigger, setCloneTrigger] = useState(null);

  const { key: billingKey, url: billingUrl } = getBillingById(id);
  const { key: cloneKey, url: cloneUrl } = getEngagementCloneByEngagementId(id);

  const { key: timesheetKey, url: timesheetUrl } =
    getTimeSheetByengagementId(id);

  const { key: billingListKey, url: billingListUrl } = getAllBillList(
    id,
    `?${queryString}`
  );

  const { data: engagementDataRes, isEngageLoader } = useFetch(key, url, { enabled: !!id });

  const { data: engagementCloneDataRes, isLoadings } = useFetch(
    [cloneKey, id, cloneTrigger],
    cloneUrl,
    { enabled: !!id && !!cloneTrigger && !isCloned && !isCloning }
  );

  const engagementData = engagementDataRes?.data;
  const { data: billingList } = useFetch(billingKey, billingUrl, {
    enabled: !!id,
  });
  const { data: timeSheetList } = useFetch(timesheetKey, timesheetUrl, {
    enabled: !!id,
  });




  useEffect(() => {
    if (shouldClone && engagementCloneDataRes?.data?.engagementId && !isLoadings) {
      const newId = engagementCloneDataRes.data.engagementId;

      // clear clone flag first → avoids reusing old data next time
      setShouldClone(false);
      setIsCloned(true);

      window.open(`/engagement/${newId}?cloned=true`, "_blank");
    }
  }, [engagementCloneDataRes, shouldClone, isLoadings]);


  const { key: actualSummaryKey, url: actualSummaryUrl } =
    queryKeys.getActualSummaryToEngagementId(id);

  const { data: actualSummaryData } = useFetch(
    actualSummaryKey,
    actualSummaryUrl,
    {
      enabled: !!id,
      // onSuccess: (response) => {
      //   setActualSummaryState(response?.response?.data);
      //   dispatch(setActualSummaryData(response?.response?.data));
      // },
      // onError: (error) => {
      //   console.error("Error fetching actual summary:", error);
      //   setActualSummaryState(null);
      //   dispatch(setActualSummaryData(null));
      // },
    }
  );

  const { key: unApprovedKey, url: unapprovedUrl } =
    queryKeys.unapprovedTimesheets;
  const { mutate: unapprovedTimesheets } = useMutate(
    unApprovedKey,
    unapprovedUrl
  );

  const { data, lastElementRef, refetch } = useScrollFetch2(
    billingListKey,
    { endPoint: billingListUrl, queryParam: "lastEvaluatedKey" },
    { enabled: !!id }
  );
  const claimedIds = new Set(
    data?.response?.items?.flatMap((item) =>
      item.claims?.map((claim) => claim.claimsId)
    )
  );

  const billingData = useMemo(() => {
    return (
      billingList?.response?.items?.filter(
        (val) =>
          val?.statusname === "Approved"
      ) ?? []
    );
  }, [billingList]);

  const actualSummaryTimeSheetData = useMemo(() => {
    return actualSummaryData?.response?.data ?? [];
  }, [actualSummaryData]);

  const employeeLists =
    Array.from(
      new Map(
        engagementData?.employeeList
          ?.filter((item) => item?.userId !== null)
          ?.map((item) => [item?.resourceId, item])
      ).values()
    ) || [];

  const matched = [];

  actualSummaryTimeSheetData?.forEach((ts) => {
    ts?.actualTimesheet
      ?.filter((entry) => entry.status === "approved")
      ?.forEach((entry) => {
        const emp = employeeLists.find(
          (e) =>
            ts?.userId === e?.userId && Number(entry?.resourceId) === e?.resourceId
        );

        const alreadyMatched = matched?.find(
          (m) => m?.userId === ts?.userId && m?.resourceId === entry?.resourceId
        );

        if (emp && !alreadyMatched) {
          matched?.push({
            userId: ts?.userId,
            resourceId: entry?.resourceId,
            approvedHours: entry?.sum,
          });
        }
      });
  });

  const billingDisbursement = sumBy(billingData, (item) => {
    return sumBy(item.claims, (claim) => parseFloat(claim.amount));
  });

  const timeSheetData = useMemo(() => {
    return timeSheetList?.response?.response ?? [];
  }, [timeSheetList]);

  const { key: claimsKey, url: cliamsUrl } = getClaims(
    engagementData?.engagementId,
    engagementData?.clientId
  );
  const conversionRate = parseFloat(engagementData?.financial_resourcePlan?.conversion_rate);
  let finalamount = billingDisbursement * (conversionRate || 1);
  const { isLoading } = useFetch(claimsKey, cliamsUrl, {
    enabled: !!id,
    onSuccess: (data) => {
      setClaimsData(data?.response?.data);
    },
  });

  useEffect(() => {
    let mergedList = (
      engagementData?.employeeList ??
      tempEngagementFormData?.resourceList ??
      []
    )?.map((employee) => {
      let user = userList?.find((user) => user?.userid === employee?.userId);
      return {
        ...employee,
        chargeoutrate: user ? user.chargeoutrate.toString() : 0, // Convert to string for consistency
      };
    });


    const budjetChargeout = (mergedList ?? [])
      .filter((item) => item.personDay !== undefined && !isNaN(item.personDay))
      .map((item) => {
        const chargeRate = parseFloat(item?.resourceExtRate ?? item?.chargeoutrate);
        return !isNaN(chargeRate) ? chargeRate * item.personDay * 8 : 0;
      })
      .reduce((acc, value) => acc + value, 0);

    setBudjetChargeout(budjetChargeout);
  }, [engagementData]);

  // const convertionRate = currencyMasterData.find(
  //   (currency) => currency.TBD_DESC === formValues?.currency
  // )?.TBD_ABBR;

  const disbursementClaims = sumBy(timeSheetData, (item) =>
    item?.timesheetDisbursement
      ? item?.timesheetDisbursement
      : (item?.claimsDisbursement || 0)
  ) * (parseFloat(convertionRate) || 1);

  const actualBillingAmount = sumBy(
    billingData,
    (item) =>
      (parseFloat(item?.amount) || 0) * (parseFloat(convertionRate) || 1)
  );



  useEffect(() => {
    if (engagementData && !isLoadings && !isLoading) {
      setLoader(false);
    }
  }, [engagementData, isLoadings, isLoading]);



  useEffect(() => {
    // Calculate the total billing amount
    const totalBilling = actualBillingAmount;
    // Calculate the total timeSheet cost
    const totalActualChargeoutAmount = matched?.reduce((total, item) => {
      const emp = employeeLists?.find(
        (e) =>
          e?.userId === item?.userId && Number(item?.resourceId) === e?.resourceId
      );

      const user = userList?.find(
        (user) => user.userid?.toLowerCase() === item?.userId?.toLowerCase()
      );

      const rate = parseFloat(emp?.resourceExtRate ?? user?.chargeoutrate ?? 0);

      // Get total approved hours for this resourceId + userId
      const tsEntry = actualSummaryTimeSheetData?.find(
        (ts) => ts?.userId === item?.userId
      );

      const approvedHours =
        tsEntry?.actualTimesheet
          ?.filter(
            (ts) =>
              ts?.resourceId.toString() === item?.resourceId?.toString() &&
              ts?.status === "approved"
          )
          ?.reduce((acc, ts) => acc + (parseFloat(ts?.sum) || 0), 0) || 0;

      return total + approvedHours * rate;
    }, 0);

    const disbursementClaims = sumBy(timeSheetData, (item) =>
      item?.timesheetDisbursement
        ? item?.timesheetDisbursement
        : (item?.claimsDisbursement || 0)
    ) * (parseFloat(convertionRate) || 1);

    // Calculate the total subcontractor amount
    const totalSubcontractorAmount = sumBy(
      timeSheetData,
      (item) => parseFloat(item?.timesheetSubcontract ? item?.timesheetSubcontract : item?.claimsSubcontract) || 0
    );

    // Calculate the total Bill Disbursement amount
    const totalBillDisbursementAmount = billingDisbursement;

    // Calculate the profit loss
    // Actual Calculation New flow
    // Billing amounts + Bill Disbsustment (New row which is coming from Billing Claims ) - Chargeout (Timehsset) - Claims (Both Subcont + dissbuontm
    const profitLoss =
      totalBilling +
      totalBillDisbursementAmount -
      totalActualChargeoutAmount -
      (disbursementClaims + totalSubcontractorAmount);

    setProfitLoss(profitLoss);
  }, [billingData, timeSheetData, engagementData, actualBillingAmount]);

  const budgetedProfit =
    parseFloat(
      typeof formValues?.usd_amount === "string"
        ? formValues?.usd_amount?.replace(/,/g, "")
        : formValues?.usd_amount || 0
    ) -
    (parseInt(budjetChargeout) +
      parseInt(
        sumBy(
          (
            engagementData?.subcontractor ??
            tempEngagementFormData?.subcontractList
          )?.map((item) => ({
            ...item,
            amount: parseInt(item.amount, 10) || 0,
          })),
          "amount"
        )
      ));

  const createdBy = engagementData?.createdBy;

  const canAbleToClose =
    userInfo?.userid === createdBy ||
    userInfo?.userid === formValues?.partner ||
    userInfo?.userid === formValues?.person_incharge || userInfo?.roleId === "8";

  const handleUnapproveTimesheets = () => {
    fetchUnapprovedTimesheets();
    setIsUnapprovedTimesheetModalVisible(true);
  };

  const handleClaims = () => {
    setIsClaimsModalVisible(true);
  };

  const handleClone = () => {
    Modal.confirm({
      title: "Are you want to clone engagement?",
      okText: "Yes",
      okType: "primary",
      cancelText: "No",
      centered: true,
      onOk() {
        hasRedirected.current = false;
        setShouldClone(true);
        setCloneTrigger(Date.now())

      },
    });
  };

  const fetchUnapprovedTimesheets = () => {
    const uniqueUserIds = [
      ...new Set(
        (engagementData?.employeeList || [])
          ?.map((item) => item.userId)
          ?.filter((id) => id !== null && id !== "")
      ),
    ];

    const payload = {
      resourceList: uniqueUserIds,
      engagementId: id,
    };
    setIsLoadingUnapprovedTimesheets(true);
    unapprovedTimesheets(payload, {
      onSuccess: (res) => {
        setUnapprovedData(
          res?.response?.response || []
        );
        setIsLoadingUnapprovedTimesheets(false);
      },
      onError: () => {
        setIsLoadingUnapprovedTimesheets(false);
      },
    });
  };

  const formatWeek = (weekStr) => {
    const [start, end] = weekStr.split("-");
    const startDate = moment(start, "YYYYMMMDD").format("DD MMM YYYY");
    const endDate = moment(end, "YYYYMMMDD").format("DD MMM YYYY");
    return `${startDate} to ${endDate}`;
  };

  const partnerUser = userList.find(
    (user) => user.userid === engagementData?.stakeHolder?.partner
  );
  const personInchargeUser = userList.find(
    (user) => user.userid === engagementData?.stakeHolder?.personIncharge
  );
  const closedByOptions = [
    partnerUser
      ? {
        label: `${partnerUser.fullname} (Partner)`,
        value: partnerUser.userid,
      }
      : null,
    personInchargeUser
      ? {
        label: `${personInchargeUser.fullname} (Person Incharge)`,
        value: personInchargeUser.userid,
      }
      : null,
  ].filter(Boolean);


  return (
    <>
      {isUnapprovedTimesheetModalVisible && (
        <Modal
          style={{ width: "700px" }}
          title="Unapproved Timesheets"
          visible={isUnapprovedTimesheetModalVisible}
          onCancel={() => setIsUnapprovedTimesheetModalVisible(false)}
          footer={null}
          width={700}
        >
          {isLoadingUnapprovedTimesheets ? (
            <Skeleton active paragraph={{ rows: 5 }} />
          ) : (
            <StyledTable
              dataSource={unapprovedData}
              rowKey={(record) => record?.timeSheetId}
              pagination={false}
            >
              <Table.Column
                title="Name"
                dataIndex="employeeName"
                key="employeeName"
              />
              <Table.Column
                title="Week Ending"
                dataIndex="week"
                key="week"
                render={(text) => {
                  const [start, end] = text.split("-");
                  const formatDate = (dateStr) => {
                    const year = dateStr.slice(0, 4);
                    const month = dateStr.slice(4, 7);
                    const day = dateStr.slice(7);
                    return `${day} ${month} ${year}`;
                  };
                  return `${formatDate(start)} - ${formatDate(end)}`;
                }}
              />
              <Table.Column
                title="Task"
                key="task"
                render={(_, record) => {
                  const taskForEngagement = record?.timeSheet
                    ?.filter(item => item?.engagement === id)
                    ?.map(item => item?.task)
                    ?.filter(Boolean); // filter out null/undefined task

                  // Join task if any, else fallback to "-"
                  return taskForEngagement && taskForEngagement?.length > 0
                    ? taskForEngagement?.join(" - ")
                    : "--";
                }}
              />
              <Table.Column
                title="Hours"
                key="sum"
                render={(_, record) => record?.timeSheet?.filter(item => item?.engagement === id)
                  ?.reduce((acc, item) => acc + item?.sum, 0) || 0}
              />
              <Table.Column
                title="Remarks"
                key="remarks"
                render={(_, record) => {
                  const remarksForEngagement = record?.timeSheet
                    ?.filter(item => item?.engagement === id)
                    ?.map(item => item?.remarks)
                    ?.filter(Boolean); // filter out null/undefined remarks

                  // Join remarks if any, else fallback to "-"
                  return remarksForEngagement && remarksForEngagement?.length > 0
                    ? remarksForEngagement?.join(" - ")
                    : "--";
                }}
              />
              <Table.Column
                title="Claim Amount"
                key="rate"
                render={(_, record) => record?.timeSheet?.filter(item => item?.engagement === id) // Only matching engagement
                  ?.flatMap(item => item?.claims || [])     // Flatten all claims arrays
                  ?.reduce((sum, claim) => sum + parseFloat(claim?.amount || 0), 0)
                }
              />
            </StyledTable>
          )}
        </Modal>
      )}
      {isClaimsModalVisible && (
        <Modal
          title="Claims"
          visible={isClaimsModalVisible}
          onCancel={() => setIsClaimsModalVisible(false)}
          footer={null}
          width={1100}
        >
          {isLoading ? (
            <Skeleton active paragraph={{ rows: 5 }} />
          ) : (
            <StyledTable
              dataSource={claimsData}
              rowKey={(record) => record?.claimsId}
              pagination={false}
              rowClassName={(record) =>
                claimedIds.has(record?.claimsId) ? "highlighted-disabled" : ""
              }
            >
              <Table.Column
                title={
                  <span style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                    Description
                  </span>
                }
                dataIndex="description"
                key="description"
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
              <Table.Column
                title={
                  <span style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                    VAT / Non-VAT
                  </span>
                }
                key="vat_non_vat"
                render={(_, record) =>
                  record?.vat ? "VAT" : record?.non_vat ? "Non-VAT" : "-"
                }
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
              <Table.Column
                title={
                  <span style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                    Type
                  </span>
                }
                dataIndex="type"
                key="type"
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
              <Table.Column
                title="Currency"
                dataIndex="currency"
                key="currency"
                onCell={() => ({ style: { whiteSpace: "nowrap" } })}
              />
              <Table.Column
                title="Amount"
                dataIndex="amount"
                key="amount"
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
              <Table.Column
                title={
                  <span style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                    SubmittedBy
                  </span>
                }
                dataIndex="submittedby"
                key="submittedby"
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
              <Table.Column
                title={
                  <span style={{ whiteSpace: "nowrap", textAlign: "center" }}>
                    Timesheet Week
                  </span>
                }
                dataIndex="week"
                key="week"
                render={(text) => formatWeek(text)}
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
              <Table.Column
                title="Date"
                dataIndex="date"
                key="date"
                render={(text) => moment(text).format("DD-MM-YYYY")}
                onCell={() => ({
                  style: { whiteSpace: "nowrap", textAlign: "center" },
                })}
              />
            </StyledTable>
          )}
        </Modal>
      )}
      {/* <Spin spinning={cloneloader && isCloned} size="small"> */}
      <Card className="fields-card">
        <Row gutter={24}>
          <Col flex="auto" className="mb-2">
            <StyleTable
              bordered
              columns={[
                {
                  title: "",
                  dataIndex: "column1",
                  key: "column1",
                },
                {
                  title: "Budget(USD)",
                  dataIndex: "budget",
                  key: "budget",
                  className: "align-right", // Add this class
                },
                {
                  title: "Actual(USD)",
                  dataIndex: "actual",
                  key: "actual",
                  className: "align-right", // Add this class
                },
              ]}
              dataSource={[
                {
                  column1: "Billing Amount",
                  budget:
                    currencyAmount(
                      "$",
                      parseFloat(
                        typeof formValues?.usd_amount === "string"
                          ? formValues?.usd_amount?.replace(/,/g, "")
                          : formValues?.usd_amount || 0
                      )
                    ) || currencyAmount("$", 0),
                  actual:
                    currencyAmount("$", actualBillingAmount) ??
                    currencyAmount("$", 0),
                },
                // {
                //   column1: "Billing Disbursement(Claims)",
                //   budget: currencyAmount("$", 0),
                //   actual:
                //     timeSheetData?.length > 0
                //       ? currencyAmount(
                //           "$",
                //           sumBy(timeSheetData, item => item?.claimsDisbursement || 0)
                //         )
                //       : currencyAmount("$", 0),
                // },

                {
                  column1: "Billing Disbursement",
                  budget: currencyAmount("$", 0),
                  actual: currencyAmount("$", finalamount),
                },

                {
                  column1: "Chargeout",
                  budget:
                    currencyAmount("$", budjetChargeout) ||
                    currencyAmount("$", 0),
                  actual:
                    currencyAmount(
                      "$",
                      matched?.reduce((total, item) => {
                        const emp = employeeLists?.find(
                          (e) =>
                            e?.userId === item?.userId &&
                            Number(item?.resourceId) === e?.resourceId
                        );

                        const user = userList?.find(
                          (user) =>
                            user?.userid?.toLowerCase() === item?.userId?.toLowerCase()
                        );

                        const rate = parseFloat(
                          emp?.resourceExtRate ?? user?.chargeoutrate ?? 0
                        );

                        // Get total approved hours for this resourceId + userId
                        const tsEntry = actualSummaryTimeSheetData?.find(
                          (ts) => ts?.userId === item?.userId
                        );

                        const approvedHours =
                          tsEntry?.actualTimesheet
                            ?.filter(
                              (ts) =>
                                ts?.resourceId.toString() === item?.resourceId.toString() &&
                                ts?.status === "approved"
                            )
                            ?.reduce((acc, ts) => acc + (parseFloat(ts?.sum) || 0), 0) || 0;

                        return total + approvedHours * rate;
                      }, 0)
                    ) || currencyAmount("$", 0),
                },

                {
                  column1: "Disbursement(Claims)",
                  budget: currencyAmount("$", 0),
                  actual:
                    timeSheetData?.length > 0
                      ? currencyAmount("$", disbursementClaims)
                      : currencyAmount("$", 0),
                },

                // {
                //   column1: "Disbursement from Timesheet",
                //   budget: currencyAmount("$", 0),
                //   actual:
                //     timeSheetData?.length > 0
                //       ? currencyAmount(
                //           "$",
                //           sumBy(timeSheetData, item => item?.billDisbursement || 0)
                //         )
                //       : currencyAmount("$", 0),
                // },
                {
                  column1: "Subcontract(Claims)",
                  budget:
                    currencyAmount(
                      "$",
                      sumBy(
                        (
                          engagementData?.subcontractor ??
                          tempEngagementFormData?.subcontractList
                        )?.map((item) => ({
                          ...item,
                          amount: parseInt(item.amount, 10) || 0, // Convert to integer, default to 0 if NaN
                        })),
                        "amount"
                      )
                    ) ?? currencyAmount("$", 0),
                  actual:
                    timeSheetData?.length > 0
                      ? currencyAmount(
                        "$",
                        sumBy(timeSheetData, (item) =>
                          item?.timesheetSubcontract
                            ? item?.timesheetSubcontract
                            : item?.claimsSubcontract || 0
                        )
                      )
                      : currencyAmount("$", 0),
                },
                {
                  column1: "Profit",
                  budget: (
                    <span className={budgetedProfit > 0 ? "profit" : "loss"}>
                      {currencyAmount("$", budgetedProfit) ||
                        currencyAmount("$", 0)}
                    </span>
                  ),
                  actual: (
                    <span className={profitLoss > 0 ? "profit" : "loss"}>
                      {currencyAmount("$", profitLoss) ||
                        currencyAmount("$", 0)}
                    </span>
                  ),
                },
                {
                  column1: "PFA(Planned fee Adjustment) USD",
                  budget:
                    budgetedProfit < 0
                      ? currencyAmount("$", Math.abs(budgetedProfit))
                      : currencyAmount("$", 0),
                  actual: "",
                },
                {
                  column1: "Profit - after PFA",
                  budget:
                    budgetedProfit > 0
                      ? currencyAmount("$", budgetedProfit)
                      : currencyAmount("$", 0),
                  actual: "",
                },
              ]}
              pagination={false}
            // scroll={{ y: 340 }}
            />
          </Col>
          <Col flex="auto">
            {/* Status */}
            <Form.Item
              label={<span style={labelStyle}>Status</span>}
              name="status"
            >
              <Select
                disabled={formValues?.status !== "Active"}
                placeholder="Select"
                onChange={(value) => {
                  if (value === "Closed") {
                    handleCloseEngagementViaModal();
                  }
                }}
                options={[
                  // { label: "Not Started", value: "Not-Started" },
                  { label: "Active", value: "Active" },
                  // { label: "Not Approved", value: "Not Approved" },
                  {
                    label: "Closed",
                    value: "Closed",
                    disabled: canAbleToClose
                      ? false
                      : formValues?.sent_to_referaal
                        ? false
                        : true, // Disable if sent_to_referral is false
                  },
                ].filter(Boolean)}
              />
            </Form.Item>
            {validationError && (
              <div style={{ marginTop: "16px", textAlign: "center" }}>
                {validationError.includes("Billing") && (
                  <Button
                    type="primary"
                    style={{ marginTop: "10px" }}
                    onClick={() =>
                      history.push("/approvals", { tabId: "billing_approval" })
                    }
                  >
                    Go to Billing
                  </Button>
                )}
              </div>
            )}
            {update && (
              <div className="job-closer-buttons-container">
                <Row
                  gutter={[8, 8]}
                  style={{
                    marginTop: "1rem",
                  }}
                >
                  <Col span={12}>
                    <Button
                      className="custom-engagement-btn"
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        history.push(`/engagement/${id}/financialsummary`);
                      }}
                    >
                      Financial Summary
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      className="custom-engagement-btn"
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        history.push(`/engagement/${id}/billing`);
                      }}
                      disabled={
                        // engagementData?.jobCloser?.status === "Not Started" ||
                        engagementData?.jobCloser?.status === "Not Approved"
                      }
                    >
                      Billing
                    </Button>
                  </Col>
                  {/* <Col span={12}>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        setShowBilling(true);
                      }}
                    >
                      Billing
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                    >
                      Financial Summary
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                    >
                      Claims
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      type="primary"
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        history.push("/engagement/1/client-survey");
                      }}
                    >
                      Client Survey
                    </Button>
                  </Col> */}
                </Row>
                <Row gutter={[8, 8]} style={{ marginTop: "1rem" }}>
                  <Col span={12} className="mt-2">
                    <Button
                      className="custom-engagement-btn"
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={() => handleUnapproveTimesheets()}
                      disabled={
                        // engagementData?.jobCloser?.status === "Not Started" ||
                        engagementData?.jobCloser?.status === "Not Approved"
                      }
                    >
                      Unapproved Timesheets
                    </Button>
                  </Col>
                  <Col span={12} className="mt-2">
                    <Button
                      className="custom-engagement-btn"
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={() => handleClaims()}
                    >
                      Claims
                    </Button>
                  </Col>
                </Row>
                <Row gutter={[8, 8]} style={{ marginTop: "1rem" }}>

                  <Col span={12} className="mt-2">
                    <Button
                      className="custom-engagement-btn"
                      type="primary"
                      loading={shouldClone}
                      style={{
                        width: "100%",
                        ...(engagementData?.jobCloser?.status !== "Closed"
                          ? {
                            backgroundColor: "#d9d9d9 !important",
                            borderColor: "#d9d9d9",
                            color: "#999",

                          }
                          : {}),
                      }}
                      disabled={engagementData?.jobCloser?.status !== "Closed"}
                      onClick={() => {
                        if (engagementData?.jobCloser?.status === "Closed") {
                          handleClone();
                          setIsCloned(false);
                        } else {
                          message.error("Clone Engagement is available for closed Engagement");
                        }
                      }}
                    >
                      Clone
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            {engagementData?.jobCloser?.status === "Closed" && (
              <div style={{ marginTop: 24 }}>
                <Form.Item
                  label={<span style={labelStyle}>Closed On</span>}
                  name="closeddate"
                  rules={[
                    { required: true, message: "Please enter Closed Date!" },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"DD-MM-YYYY"}
                    disabledDate={(current) =>
                      current && current < moment().endOf("day")
                    }
                    disabled={disabled}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={labelStyle}>Closed By</span>}
                  name="closedby"
                  rules={[
                    {
                      required: true,
                      message: "Please select who closed the engagement!",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select"
                    showSearch={true}
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input.toLowerCase()
                      )
                    }
                    options={closedByOptions}
                    disabled={disabled}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={labelStyle}>Comment</span>}
                  name="close_comment"
                  rules={[
                    {
                      required: true,
                      message: "Please enter a comment!",
                    },
                  ]}
                >
                  <textarea
                    className="ant-input"
                    style={{ width: "100%", minHeight: 60, resize: "vertical" }}
                    placeholder="Enter comment"
                    disabled={disabled}
                  />
                </Form.Item>
              </div>
            )}
          </Col>
        </Row>

        <UIModal
          open={showBilling}
          onClose={() => setShowBilling(false)}
          header={"Billing"}
        >
          {/* //TODO: Implement Billing UI */}
        </UIModal>
      </Card>
      {/* </Spin> */}
    </>
  );
};

export default JobCloserFields;

const StyleTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #dbdbdb;
    font-weight: 700;
  }
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > thead
    > tr
    > th {
    border-right: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table
    > tbody
    > tr
    > td {
    border-right: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered
    > .ant-table-container
    > .ant-table-content
    > table {
    border-top: 1px solid #dbdbdb;
  }
  .ant-table.ant-table-bordered > .ant-table-container {
    border-left: 1px solid #dbdbdb;
  }
  .ant-table-cell {
    padding: 7px 12px;
    font-size: 16px;
    font-weight: 500;
  }
  .ant-table-container {
    border-radius: 5px;
  }
  .ant-table {
    border-radius: 5px;
  }
  .align-right {
    text-align: right; // Add this style
  }
`;